import { DatasetResult, FlamingoTypes, SwitchViewDomain } from '@mode/shared/contract-common';
import { createAction, props } from '@ngrx/store';
import { SwitchViewsRankMap } from 'libs/shared/contract-common/src/lib/switch/switch-view.types';

export const startPolling = createAction(
  '[SwitchView] StartPolling',
  props<{
    accountId: string;
    reportToken: string;
    tokens: ReadonlyArray<string>;
    reportRunId: string;
  }>()
);

export const startEditorPolling = createAction(
  '[SwitchView] StartEditorPolling',
  props<{
    reportToken: string;
    switchViewTokens: ReadonlyArray<string>;
    reportRunId: string;
  }>()
);

export const setPendingDatasetResult = createAction(
  '[SwitchView] SetPendingDatasetResult',
  props<{
    switchViewToken: string;
  }>()
);

export const setPendingDatasetResults = createAction(
  '[SwitchView] SetPendingDatasetResults',
  props<{
    switchViewTokens: string[];
  }>()
);

export const deleteSwitchViewResourcesFromCache = createAction(
  '[SwitchView] DeleteSwitchViewResourcesFromCache',
  props<{
    switchViewTokens: ReadonlyArray<string>;
  }>()
);

export const pollingSwitchViewCompleted = createAction(
  '[SwitchView] Polling SwitchView Completed',
  props<{ dataView: SwitchViewDomain.DataView }>()
);
export const loadExplorationDataView = createAction(
  '[Charts] LoadExplorationDataView',
  props<{ dataView: SwitchViewDomain.DataView }>()
);
export const loadVisualizationDataView = createAction(
  '[Charts] LoadVisualizationDataView',
  props<{ dataView: SwitchViewDomain.DataView }>()
);

export const loadGfDataViews = createAction(
  '[Charts] LoadGfDataViews',
  props<{ dataViews: ReadonlyArray<SwitchViewDomain.DataView> }>()
);

export const loadReportViewDataViews = createAction(
  '[Report View Data View] Load Data View',
  props<{ dataViews: ReadonlyArray<SwitchViewDomain.DataView> }>()
);

export const queryRawDatasetAngularJs = createAction(
  '[SwitchView] QueryRawDatasetAngularJs',
  props<{
    queryToken: string;
  }>()
);

export const queryRawDataset = createAction(
  '[SwitchView] QueryRawDataset',
  props<{
    queryToken: string;
  }>()
);

export const queryDatasetWithCalcs = createAction(
  '[SwitchView] QueryDatasetWithCalcs',
  props<{
    queryToken: string;
  }>()
);

export const openCalcEditor = createAction(
  '[SwitchView] OpenCalcEditor',
  props<{
    switchViewToken: string;
    viewName: string;
    viewMode: 'static' | 'edit';
    calc?: FlamingoTypes.ModeCalc;
    readOnly?: boolean;
    duplicate?: boolean;
    isImportedDataset?: boolean;
    canShowFieldDescription?: boolean;
  }>()
);

export const loadEditorViews = createAction('[Report Editor] loadEditorViews', props<{ reportToken: string }>());

export const loadEditorViewsSuccess = createAction(
  '[Report Editor] loadEditorViewsSuccess',
  props<{ reportToken: string; dataViews: ReadonlyArray<SwitchViewDomain.DataView> }>()
);

export const refreshEditorViewsSuccess = createAction(
  '[Report Editor] refreshEditorViewsSuccess',
  props<{
    reportToken: string;
    exportedDatasetToken: string;
    dataViews: ReadonlyArray<SwitchViewDomain.DataView>;
  }>()
);

export const setRef = createAction('[SwitchView] SetRef', props<{ refId: string; switchViewToken: string }>());

export const setRefs = createAction(
  '[SwitchView] SetRefs',
  props<{ refs: ReadonlyArray<{ refId: string; switchViewToken: string }> }>()
);

export const deleteRef = createAction('[SwitchView] DeleteRef', props<{ refId: string }>());

export const deleteRefs = createAction('[SwitchView] DeleteRefs', props<{ refIds: ReadonlyArray<string> }>());

// Temporary action to keep local state in sync with the legacy state
// after renaming a local query from new dataset components
export const updateLocalQuerySwitchViewTitle = createAction(
  '[SwitchView] updateLocalQuerySwitchViewTitle',
  props<{
    switchViewToken: string;
    title: string;
  }>()
);

// Temporary action to keep local state in sync with the legacy state
// after the deleting a local query from new dataset components
export const deleteSwitchViewLocalQuery = createAction(
  '[SwitchView] deleteSwitchViewLocalQuery',
  props<{
    switchViewToken: string;
  }>()
);

// Temporary action to keep local state in sync with the legacy state
// after renaming a local query from new dataset components
export const addTemporaryLocalQuery = createAction(
  '[SwitchView] addTemporaryLocalQuery',
  props<{
    queryName: string;
    queryToken: string;
    isMetric: boolean;
  }>()
);

// Hydrate temporary local query with newly create queryToken
export const updateTemporaryLocalQueryToken = createAction(
  '[SwitchView] updateTemporaryLocalQueryToken',
  props<{
    tempQueryToken: string;
    queryToken: string;
  }>()
);

export const removeDatasetFromDatasetTab = createAction(
  '[SwitchView] Remove Dataset From Tab',
  props<{ accountId: string; reportId: string; switchViewToken: string }>()
);

export const removeDatasetFromSideNav = createAction(
  '[SwitchView] Remove Dataset From SideNav',
  props<{ accountId: string; reportId: string; switchViewToken: string }>()
);

export const removeDatasetSuccess = createAction(
  '[SwitchView] Remove Dataset Success',
  props<{ switchViewToken: string; producerToken?: string }>()
);

export const removeDatasetFailure = createAction(
  '[SwitchView] Remove Dataset Failed',
  props<{ switchViewToken: string; error: string }>()
);

export const clearDatasetFailure = createAction(
  '[SwitchView] Updated dataset error',
  props<{ switchViewToken: string; error: null }>()
);

export const datasetRefreshButtonClicked = createAction(
  '[Report Editor Route] Dataset Refresh Button Clicked',
  props<{ reportToken: string; switchViewToken: string }>()
);

export const datasetRefreshAllClicked = createAction(
  '[Report Editor Route] Dataset Refresh All Clicked',
  props<{ reportToken: string; switchViewTokens: string[] }>()
);

export const importedDatasetRefreshed = createAction(
  'Flamingo.RefreshDataset',
  props<{
    switchView: SwitchViewDomain.SwitchView;
    datasetResult: DatasetResult;
    shareLink: string;
    queryToken: string;
    mostRecentReportRunToken: string;
  }>()
);

export const datasetAllRefreshed = createAction(
  '[Report Editor Route] Dataset All Refreshed',
  props<{
    switchView: SwitchViewDomain.SwitchView;
    datasetResult: DatasetResult;
    shareLink: string;
    mostRecentReportRunToken: string;
  }>()
);

export const loadImportedDatasetSuccess = createAction(
  '[Report Editor] Load Imported Dataset Success',
  props<{ dataView: SwitchViewDomain.DataView; shareLink?: string; mostRecentReportRunToken?: string }>()
);

export const loadSwitchViewDefinitonRoute = createAction(
  '[Definition Editor Route] Load SwitchView',
  props<{ switchViewToken: string }>()
);

export const loadSwitchViewSuccess = createAction(
  '[Switch Views] Loading Switch View Succeeded',
  props<{ switchView: SwitchViewDomain.SwitchView; datasetResult: DatasetResult }>()
);

export const loadQueryRunSuccess = createAction(
  '[Report] loadQueryRunSuccess',
  props<{ switchViewToken: string; rawSource: string; renderedSource: string; error: string }>()
);

// Re-ordering actions
export const reorderDatasets = createAction(
  '[Switch Views] reorderDatasets',
  props<{ reportToken: string; switchViewToken: string; prevSwitchViewToken: string | null }>()
);

export const reorderDatasetsSuccess = createAction(
  '[Switch Views] reorderDatasetsSuccess',
  props<{ switchViewsRankMap: SwitchViewsRankMap }>()
);

export const openDuplicateDialog = createAction(
  '[Report Editor] Open Duplicate Dialog',
  props<{ onDuplicateConfirm: () => void; isPublished: boolean; isSecretExist: boolean }>()
);

export const triggerPublishProgressToast = createAction(
  '[Report Editor] Trigger Publish Progress Toast',
  props<{ switchViewToken: string }>()
);

export const reorderDatasetsFailure = createAction('[Switch Views] reorderDatasetsFailure', props<{ error: string }>());

export type StartPolling = ReturnType<typeof startPolling>;
export type StartEditorPolling = ReturnType<typeof startEditorPolling>;
export type SetPendingDatasetResult = ReturnType<typeof setPendingDatasetResult>;
export type DeleteSwitchViewResourcesFromCache = ReturnType<typeof deleteSwitchViewResourcesFromCache>;
export type QueryRawDataset = ReturnType<typeof queryRawDataset>;
export type QueryRawDatasetAngularJs = ReturnType<typeof queryRawDatasetAngularJs>;
export type QueryDatasetWithCalcs = ReturnType<typeof queryDatasetWithCalcs>;
export type OpenCalcEditor = ReturnType<typeof openCalcEditor>;
export type UpdateLocalQuerySwitchViewTitle = ReturnType<typeof updateLocalQuerySwitchViewTitle>;

export type Union =
  | StartPolling
  | StartEditorPolling
  | SetPendingDatasetResult
  | DeleteSwitchViewResourcesFromCache
  | QueryRawDataset
  | QueryRawDatasetAngularJs
  | QueryDatasetWithCalcs
  | OpenCalcEditor
  | UpdateLocalQuerySwitchViewTitle
  | ReturnType<typeof pollingSwitchViewCompleted>
  | ReturnType<typeof loadGfDataViews>
  | ReturnType<typeof loadExplorationDataView>
  | ReturnType<typeof loadVisualizationDataView>
  | ReturnType<typeof loadReportViewDataViews>
  | ReturnType<typeof setRef>
  | ReturnType<typeof setRefs>
  | ReturnType<typeof deleteRef>
  | ReturnType<typeof deleteRefs>
  | ReturnType<typeof loadEditorViews>
  | ReturnType<typeof loadEditorViewsSuccess>
  | ReturnType<typeof refreshEditorViewsSuccess>
  | ReturnType<typeof loadImportedDatasetSuccess>
  | ReturnType<typeof importedDatasetRefreshed>
  | ReturnType<typeof datasetAllRefreshed>
  | ReturnType<typeof triggerPublishProgressToast>;
